import { Component, Input, OnInit } from '@angular/core';
import { getSupportEmail } from 'helpers';

@Component({
    selector: 'fc-signup-sent',
    templateUrl: './signup-sent.component.html',
    styleUrls: ['./signup-sent.component.less'],
    standalone: false
})
export class SignupSentComponent implements OnInit {
    @Input() origin: 'referralSignup' | 'normalSignup' | 'existingOrgSignup' = 'referralSignup';
    supportEmail = getSupportEmail();
    text: {
        title: string;
        description: string;
    } = {
        title: '',
        description: ''
    };

    ngOnInit(): void {
        if (this.origin === 'referralSignup') {
            this.setReferralSignupText();
        } else if (this.origin === 'existingOrgSignup') {
            this.setExistingOrgSignupText();
        } else {
            this.setNormalSignupText();
        }
    }

    private setReferralSignupText(): void {
        this.text = {
            title: 'SIGNUP.REFERRAL.REQUEST_SENT.TITLE',
            description: 'SIGNUP.REFERRAL.REQUEST_SENT.DESCRIPTION'
        };
    }

    private setNormalSignupText(): void {
        this.text = {
            title: 'SIGNUP.NORMAL.REQUEST_SENT.TITLE',
            description: 'SIGNUP.NORMAL.REQUEST_SENT.DESCRIPTION'
        };
    }

    private setExistingOrgSignupText(): void {
        this.text = {
            title: 'SIGNUP.EXISTING_ORG.REQUEST_SENT.TITLE',
            description: 'SIGNUP.EXISTING_ORG.REQUEST_SENT.DESCRIPTION'
        };
    }
}
